import React from 'react';
import { motion } from 'framer-motion';

/**
 * GlassCard - Glassmorphism card component
 * Non-breaking wrapper that adds glassmorphism effect
 * Preserves all children and functionality
 */
const GlassCard = ({ 
  children, 
  className = '',
  hover = true,
  ...props 
}) => {
  return (
    <motion.div
      className={`glass-card rounded-2xl shadow-xl ${className}`}
      whileHover={hover ? { 
        scale: 1.02,
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.15)',
        transition: { duration: 0.2 }
      } : undefined}
      {...props}
    >
      {children}
    </motion.div>
  );
};

export default GlassCard;
